import createVueApp from '@/common/createApp'

Styxie.Initializers.LocalOpticsQuoteCheckouts = {
  show: async(props) => {
    const { default: QuoteCheckout } = await import('@/vue_widgets/local_optics/checkout/QuoteCheckout.vue')
    createVueApp(QuoteCheckout, { props })
  }
}
